<template>
  <main class="mobile-page order-screen" :class="{ 'order-screen-expanded': step === 'form' || step === 'contract' || (step === 'pay' && paymentOpened && canPay && payMethod === 'ALIPAY') }">
    <div class="mobile-screen">
      <header class="mobile-topnav">
        <span class="nav-side">
          <RouterLink class="mobile-icon-btn" to="/mobile/employee" aria-label="返回产品详情">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M14.5 5.5 8 12l6.5 6.5" /></svg>
          </RouterLink>
        </span>
        <span class="mobile-topnav-title">移动端下单</span>
        <span class="nav-side nav-service-side">
          <button class="service-trigger" type="button" aria-haspopup="dialog" :aria-expanded="servicePanelVisible" @click="servicePanelVisible = true">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 13v-1a8 8 0 0 1 16 0v1" />
              <path d="M4 13.5a1.8 1.8 0 0 1 1.8-1.8h.9a1.3 1.3 0 0 1 1.3 1.3v2.4A1.3 1.3 0 0 1 6.7 16.7H5.8A1.8 1.8 0 0 1 4 14.9z" />
              <path d="M20 13.5a1.8 1.8 0 0 0-1.8-1.8h-.9a1.3 1.3 0 0 0-1.3 1.3v2.4a1.3 1.3 0 0 0 1.3 1.3h.9a1.8 1.8 0 0 0 1.8-1.8z" />
              <path d="M18.5 16.7v.8a3 3 0 0 1-3 3H13" />
            </svg>
<!--            <span>客服</span>-->
          </button>
        </span>
      </header>

      <div v-if="pageLoading" class="mobile-card state-card" aria-live="polite">正在加载下单信息...</div>
      <div v-else-if="pageMessage" class="mobile-card state-card error" role="alert">
        <p>{{ pageMessage }}</p>
        <button class="mobile-btn mobile-btn-primary" type="button" @click="initialize">重新加载</button>
      </div>

      <template v-else>
        <section class="order-progress" aria-label="下单进度">
          <span :class="{ active: step === 'agreement', done: step !== 'agreement' }" :aria-current="step === 'agreement' ? 'step' : undefined">协议</span>
          <i></i>
          <span :class="{ active: step === 'form', done: step === 'contract' || step === 'pay' }" :aria-current="step === 'form' ? 'step' : undefined">信息</span>
          <template v-if="isCityPartnerPackage">
            <i></i>
            <span :class="{ active: step === 'contract', done: step === 'pay' }" :aria-current="step === 'contract' ? 'step' : undefined">合同</span>
          </template>
          <i></i>
          <span :class="{ active: step === 'pay' }" :aria-current="step === 'pay' ? 'step' : undefined">支付</span>
        </section>
        <p v-if="step !== 'pay' && !canCreateOrder" class="region-message checkout-unavailable" role="status">
          {{ selectedProduct ? '当前暂未开放下单，请稍后再试。' : '暂无可购买商品，请稍后再试。' }}
        </p>

        <section v-if="step === 'agreement' || step === 'form'" class="order-body checkout-product">
          <div class="mobile-card product-card">
            <span class="mobile-eyebrow">VitaeAI · 移动下单</span>
            <label v-if="tradeProducts.length > 1" class="product-select">
              <span>选择商品</span>
              <select :value="selectedProductCode" data-order-field="productCode" :disabled="loading || Boolean(currentOrder)" @change="selectProduct($event.target.value)">
                <option v-for="item in tradeProducts" :key="item.productCode" :value="item.productCode">
                  {{ item.productName }}
                </option>
              </select>
            </label>
            <h1>{{ selectedProduct?.productName || '官方商品' }}</h1>
            <p>{{ [selectedProduct?.formText, selectedProduct?.servicePeriod].filter(Boolean).join(' · ') || '官方配置商品' }}</p>
            <p v-if="selectedProduct?.subtitle" class="product-subtitle copy-preline">{{ selectedProduct.subtitle }}</p>
            <div v-if="selectedProduct?.cooperationCondition" class="product-condition">
              <span>合作条件</span>
              <p class="copy-preline">{{ selectedProduct.cooperationCondition }}</p>
            </div>
            <div class="product-payment-tags">
              <span v-for="method in selectedProduct?.allowedPaymentMethods || []" :key="method">
                支持{{ paymentMethodText(method) }}
              </span>
            </div>
            <div class="price-row">
              <span>{{ priceLabel }}</span>
              <strong>{{ totalLabel }}</strong>
            </div>
          </div>
        </section>

        <section v-if="step === 'form'" class="order-body">
          <section v-if="selectedProductNeedDelivery" class="mobile-card form-card">
            <h2>收货信息</h2>
            <label v-if="addresses.length">
              <span>已有地址</span>
              <select v-model="selectedAddressId" @change="applyAddress">
                <option value="">新填地址</option>
                <option v-for="item in addresses" :key="item.id" :value="String(item.id)">
                  {{ item.receiverName }} · {{ fullAddress(item) }}
                </option>
              </select>
            </label>

            <label>
              <span>收货人</span>
              <input v-model="orderForm.receiverName" data-order-field="receiverName" autocomplete="shipping name" placeholder="请输入收货人" />
            </label>
            <label>
              <span>联系电话</span>
              <input v-model="orderForm.receiverPhone" data-order-field="receiverPhone" type="tel" inputmode="tel" maxlength="11" autocomplete="shipping tel" placeholder="11 位手机号" />
            </label>
            <label>
              <span>省份</span>
              <select v-model="orderForm.province" data-order-field="province" @change="changeProvince">
                <option value="">请选择省份</option>
                <option v-for="item in provinceOptions" :key="item.value" :value="item.value">{{ item.label }}</option>
              </select>
            </label>
            <label>
              <span>城市</span>
              <select v-model="orderForm.city" data-order-field="city" :disabled="!cityOptions.length" @change="changeCity">
                <option value="">请选择城市</option>
                <option v-for="item in cityOptions" :key="item.value" :value="item.value">{{ item.label }}</option>
              </select>
            </label>
            <label>
              <span>区县</span>
              <select v-model="orderForm.district" data-order-field="district" :disabled="!districtOptions.length" @change="selectedAddressId = ''; orderForm.addressId = ''">
                <option value="">请选择区县</option>
                <option v-for="item in districtOptions" :key="item.value" :value="item.value">{{ item.label }}</option>
              </select>
            </label>
            <label class="wide">
              <span>详细地址</span>
              <input v-model="orderForm.addressDetail" data-order-field="addressDetail" autocomplete="street-address" placeholder="街道、门牌号等" />
            </label>
          </section>

          <section class="mobile-card form-card">
            <h2>购买与服务</h2>
            <template v-if="isCityPartnerPackage">
              <label>
                <span>合作省份</span>
                <select v-model="cityPartnerSelection.provinceCode" data-order-field="cityPartnerSelection.provinceCode" @change="changeCityPartnerProvince">
                  <option value="">请选择省份</option>
                  <option v-for="province in cityPartnerProvinceOptions" :key="province.value" :value="province.value">
                    {{ province.label }}
                  </option>
                </select>
              </label>
              <label>
                <span>合作城市</span>
                <select
                  v-model="cityPartnerSelection.cityCode"
                  data-order-field="cityPartnerSelection.cityCode"
                  :disabled="!cityPartnerSelection.provinceCode"
                  @change="changeCityPartnerCity"
                >
                  <option value="">请选择城市</option>
                  <option v-for="city in cityPartnerCityOptions" :key="city.value" :value="city.value">
                    {{ city.label }}
                  </option>
                </select>
              </label>
              <label>
                <span>空闲区县</span>
                <select
                  v-model="orderForm.cityPartnerRequest.regionCode"
                  data-order-field="cityPartnerRequest.regionCode"
                  :disabled="cityRegionLoading || !cityPartnerSelection.provinceCode || !cityPartnerSelection.cityCode"
                  @change="syncCityRegionName"
                >
                  <option value="">{{ cityRegionLoading ? '正在加载空闲区县' : '请选择空闲合作区域' }}</option>
                  <option v-for="region in cityPartnerRegionOptions" :key="region.regionCode" :value="region.regionCode">
                    {{ region.regionName }}
                  </option>
                </select>
              </label>
              <label class="wide">
                <span>合同邮寄地址</span>
                <input
                  v-model="orderForm.cityPartnerRequest.contractMailingAddress"
                  data-order-field="cityPartnerRequest.contractMailingAddress"
                  autocomplete="street-address"
                  placeholder="公司向该地址邮寄纸质合同"
                />
              </label>
              <p v-if="cityRegionMessage" class="region-message">{{ cityRegionMessage }}</p>
              <p class="region-message">城市合伙人套餐数量固定为 1，下单后将预占所选区域；支付成功后生成合同，订单/支付审核通过后权益正式生效，合同签署进度不影响权益。</p>
            </template>
            <div class="quantity-row">
              <span>购买数量</span>
              <div>
                <button type="button" :disabled="isCityPartnerPackage || Boolean(currentOrder)" @click="changeQuantity(-1)">−</button>
                <strong>{{ orderQuantity }}</strong>
                <button type="button" :disabled="isCityPartnerPackage || Boolean(currentOrder)" @click="changeQuantity(1)">+</button>
              </div>
            </div>
            <label v-if="selectedProductNeedDelivery" class="switch-row">
              <input v-model="sameServiceContact" type="checkbox" />
              <span>软件服务联系人与收货人相同</span>
            </label>
            <template v-if="!selectedProductNeedDelivery || !sameServiceContact">
              <label>
                <span>服务联系人</span>
                <input v-model="orderForm.serviceContact" data-order-field="serviceContact" placeholder="请输入服务联系人" />
              </label>
              <label>
                <span>服务电话</span>
                <input v-model="orderForm.servicePhone" data-order-field="servicePhone" type="tel" inputmode="tel" maxlength="11" placeholder="11 位手机号" />
              </label>
            </template>
            <label class="wide">
              <span>订单备注</span>
              <textarea v-model="orderForm.remark" rows="3" placeholder="选填"></textarea>
            </label>
          </section>

          <p v-if="formError" class="field-error" role="alert">{{ formError }}</p>
        </section>

        <section v-else-if="step === 'agreement'" class="order-body">
          <div class="mobile-card summary-card">
            <span class="mobile-eyebrow">Order Summary · 订单摘要</span>
            <dl>
              <div><dt>商品</dt><dd>{{ selectedProduct?.productName || '-' }}</dd></div>
              <div><dt>数量</dt><dd>x {{ orderQuantity }}</dd></div>
              <div><dt>配送</dt><dd>{{ selectedProductNeedDelivery ? '确认协议后填写收货信息' : '无需配送' }}</dd></div>
              <div><dt>应付</dt><dd>{{ totalLabel }}</dd></div>
            </dl>
          </div>

          <section v-if="agreements.length" class="mobile-card agreement-card">
            <h2>确认订购协议</h2>
            <article v-for="agreement in agreements" :key="agreement.key" class="agreement-item">
              <details open>
                <summary>《{{ agreement.title }}》</summary>
                <div class="agreement-content" v-html="agreement.html"></div>
              </details>
              <label>
                <input v-model="acceptedKeys" type="checkbox" :value="agreement.confirmationKey" :disabled="loading || !productAgreementsReady" />
                <span>我已阅读并同意《{{ agreement.title }}》</span>
              </label>
            </article>
          </section>
          <div v-if="!productAgreementsReady" class="mobile-card state-card error" role="alert">当前商品的订购协议未配置完整或尚未发布，暂不能下单，请联系客服。</div>
        </section>

        <section v-else-if="step === 'contract'" class="order-body">
          <div class="mobile-card summary-card">
            <span class="mobile-eyebrow">Order Summary · 订单摘要</span>
            <dl>
              <div><dt>商品</dt><dd>{{ selectedProduct?.productName || '-' }}</dd></div>
              <div><dt>数量</dt><dd>x {{ orderQuantity }}</dd></div>
              <div><dt>合作区域</dt><dd>{{ orderForm.cityPartnerRequest.regionName }}</dd></div>
              <div><dt>合同邮寄地址</dt><dd>{{ orderForm.cityPartnerRequest.contractMailingAddress }}</dd></div>
              <div><dt>服务联系人</dt><dd>{{ orderForm.serviceContact }} · {{ orderForm.servicePhone }}</dd></div>
              <div v-if="selectedProductNeedDelivery"><dt>收货人</dt><dd>{{ orderForm.receiverName }} · {{ orderForm.receiverPhone }}</dd></div>
              <div v-if="selectedProductNeedDelivery"><dt>收货地址</dt><dd>{{ fullAddress(orderForm) }}</dd></div>
              <div><dt>应付</dt><dd>{{ totalLabel }}</dd></div>
            </dl>
          </div>

          <section class="mobile-card agreement-card contract-draft-card">
            <h2>确认城市合伙人合同模板</h2>
            <p class="contract-draft-note">
              请预览并确认全部合同模板。模板占位符已隐藏；订单创建、支付后将以最终订单信息生成正式合同。
            </p>
            <div v-if="contractDraftLoading" class="region-message">正在加载合同...</div>
            <template v-else>
              <article v-for="template in contractTemplates" :key="template.id" class="agreement-item contract-draft-item">
                <div class="contract-draft-title">
                  <strong>《{{ template.templateName }}》</strong>
                  <span>版本 v{{ template.templateVersion || 1 }}</span>
                </div>
                <div class="contract-draft-actions">
                  <button
                    class="mobile-btn mobile-btn-ghost"
                    type="button"
                    :disabled="contractDraftPreviewLoading"
                    @click="openContractDraftPreview(template)"
                  >
                    {{ contractDraftPreviewLoading ? '加载中...' : '查看合同模板' }}
                  </button>
                  <button
                    class="mobile-btn mobile-btn-ghost"
                    type="button"
                    :disabled="contractDraftDownloadingId === template.id"
                    @click="downloadContractDraft(template)"
                  >
                    {{ contractDraftDownloadingId === template.id ? '下载中...' : '下载合同模板' }}
                  </button>
                  <label>
                    <input v-model="acceptedContractIds" type="checkbox" :value="template.id" :disabled="loading" />
                    <span>我已阅读并同意《{{ template.templateName }}》</span>
                  </label>
                </div>
              </article>
              <p v-if="contractDraftMessage" class="region-message" :class="{ error: contractDraftError }">
                {{ contractDraftMessage }}
              </p>
              <button
                v-if="contractDraftError || !contractTemplates.length"
                class="mobile-btn mobile-btn-ghost"
                type="button"
                :disabled="loading"
                @click="loadContractDraft"
              >重新加载合同</button>
            </template>
          </section>
        </section>

        <section v-else-if="step === 'pay'" class="order-body">
          <div class="mobile-card pay-card">
            <span class="mobile-eyebrow">Payment · 支付状态</span>
            <h1>{{ payTitle }}</h1>
            <p>{{ payHint }}</p>
            <div class="pay-amount">{{ orderAmount }}</div>
            <dl class="pay-meta">
              <div><dt>订单号</dt><dd>{{ currentOrder?.orderNo || currentOrder?.id || '-' }}</dd></div>
              <div v-if="productNeedDelivery(currentOrder)"><dt>收货人</dt><dd>{{ currentOrder?.receiverName || '-' }} · {{ currentOrder?.receiverPhone || '' }}</dd></div>
              <div><dt>支付状态</dt><dd>{{ payStatusText }}</dd></div>
            </dl>
          </div>

          <OrderContractsPanel
            v-if="showPaymentContracts"
            class="payment-contract-panel"
            :order-id="currentOrder.id"
            variant="mobile"
          />

          <section v-if="canPay" class="mobile-card method-card">
            <h2>选择支付方式</h2>
            <button v-if="alipayAvailable" :class="{ active: payMethod === 'ALIPAY' }" type="button" @click="selectPayMethod('ALIPAY')">
              <strong>支付宝支付</strong><span>适合手机端快捷支付</span>
            </button>
            <button v-if="bankTransferAvailable" :class="{ active: payMethod === 'BANK_TRANSFER' }" type="button" @click="selectPayMethod('BANK_TRANSFER')">
              <strong>银行卡转账</strong><span>转账后由后台核对到账</span>
            </button>
            <p v-if="!visiblePaymentMethods.length" class="region-message">当前商品未配置可用收款方式，请联系客服。</p>
          </section>

          <section v-if="payMethod === 'BANK_TRANSFER' && (canPay || paymentVoucherView)" class="mobile-card bank-card">
            <h2>转账信息</h2>
            <dl>
              <div><dt>开户行</dt><dd>{{ bankAccountDetails.bankName || '-' }}</dd></div>
              <div><dt>户名</dt><dd>{{ bankAccountDetails.bankAccountName || '-' }}</dd></div>
              <div><dt>账号</dt><dd>{{ bankAccountDetails.bankAccountNumber || '-' }}</dd></div>
              <div v-if="bankAccountDetails.bankBranchName"><dt>开户支行</dt><dd>{{ bankAccountDetails.bankBranchName }}</dd></div>
            </dl>
            <p>{{ bankAccountDetails.bankTransferInstructions || '请转账时备注订单号，转账完成后提交核对。' }}</p>
            <div class="voucher-upload">
              <div>
                <strong>{{ canPay ? '支付凭证' : '已提交支付凭证' }}</strong>
                <span>{{ canPay ? '必填' : '后台核对' }}</span>
              </div>
              <template v-if="canPay">
                <input
                  ref="paymentVoucherInput"
                  type="file"
                  accept="image/jpeg,image/png,image/gif,image/webp"
                  @change="handlePaymentVoucherChange"
                />
                <button type="button" :disabled="paymentVoucherUploading" @click="choosePaymentVoucher">
                  {{ paymentVoucherUploading ? '正在上传凭证' : paymentVoucher ? '重新上传凭证' : '上传支付凭证' }}
                </button>
              </template>
              <div v-if="paymentVoucherView" class="voucher-preview">
                <img :src="paymentVoucherView.previewUrl || paymentVoucherView.url" :alt="paymentVoucherView.filename" />
                <div>
                  <span>{{ paymentVoucherView.filename }}</span>
                  <div class="voucher-preview-actions">
                    <a :href="paymentVoucherView.url" target="_blank" rel="noreferrer">查看原图</a>
                    <button v-if="paymentVoucher" type="button" :disabled="paymentVoucherUploading" @click="removePaymentVoucher">删除</button>
                  </div>
                </div>
              </div>
              <small v-if="paymentVoucherMessage">{{ paymentVoucherMessage }}</small>
              <p>请上传转账成功截图或银行回单图片（jpg、png、gif、webp，最大 20MB）。</p>
            </div>
          </section>
        </section>

        <p v-if="tradeMessage" class="field-error" role="alert">{{ tradeMessage }}</p>

        <div class="dock" :class="{ 'dock-actions': step === 'form' || step === 'contract', 'dock-payment-return': step === 'pay' && paymentOpened && canPay && payMethod === 'ALIPAY' }">
          <div>
            <small>{{ step === 'pay' ? '订单已创建' : `应付总额 · ${Number(selectedProduct?.freightAmount || 0) > 0 ? '含运费' : '免运费'}` }}</small>
            <strong>{{ step === 'pay' ? orderAmount : totalLabel }}</strong>
          </div>
          <button v-if="step === 'agreement'" class="mobile-btn mobile-btn-primary" type="button" :disabled="loading || !agreementsAccepted || !canCreateOrder" @click="agreeAndGoToForm">同意协议，填写订单</button>
          <template v-else-if="step === 'form'">
            <button
              v-if="isRevisingOrder"
              class="mobile-btn mobile-btn-ghost"
              type="button"
              :disabled="loading"
              @click="cancelOrderRevision"
            >
              取消修改
            </button>
            <button v-else class="mobile-btn mobile-btn-ghost" type="button" :disabled="loading" @click="goBackToAgreement">上一步</button>
            <button class="mobile-btn mobile-btn-primary" type="button" :disabled="loading || contractDraftLoading || (!isRevisingOrder && !canCreateOrder)" @click="submitOrderForm">
              {{ loading ? '正在提交' : isRevisingOrder ? '重新提交审核' : isCityPartnerPackage ? '下一步，确认合同' : '提交订单' }}
            </button>
          </template>
          <template v-else-if="step === 'contract'">
            <button class="mobile-btn mobile-btn-ghost" type="button" :disabled="loading" @click="goBackToForm">上一步</button>
            <button class="mobile-btn mobile-btn-primary" type="button" :disabled="loading || !allAccepted || !canCreateOrder" @click="createOrder">
              {{ loading ? '正在创建订单' : '同意并创建订单' }}
            </button>
          </template>
          <template v-else-if="step === 'pay'">
            <button v-if="canPay && payMethod === 'ALIPAY' && !paymentOpened" class="mobile-btn mobile-btn-primary" type="button" :disabled="loading" @click="payAlipay">
              {{ loading ? '正在打开支付宝' : '支付宝支付' }}
            </button>
            <button v-else-if="canPay && !payMethod" class="mobile-btn mobile-btn-primary" type="button" disabled>
              暂无可用收款方式
            </button>
            <button v-else-if="canPay && payMethod === 'ALIPAY'" class="mobile-btn mobile-btn-primary" type="button" :disabled="paymentCheckLoading" @click="checkPaymentStatus()">
              {{ paymentCheckLoading ? '正在确认支付结果' : '我已完成支付，检查结果' }}
            </button>
            <button v-if="step === 'pay' && canPay && payMethod === 'ALIPAY' && paymentOpened" class="mobile-btn mobile-btn-ghost" type="button" :disabled="loading" @click="retryAlipay">
              重新发起支付
            </button>
            <button v-else-if="canPay && payMethod === 'BANK_TRANSFER' && bankTransferAvailable" class="mobile-btn mobile-btn-primary" type="button" :disabled="loading || paymentVoucherUploading || bankPending" @click="submitBankTransfer">
              {{ loading ? '正在提交核对' : paymentVoucherUploading ? '正在上传凭证' : bankPending ? '转账待核对' : '我已完成转账' }}
            </button>
            <RouterLink v-else-if="!awaitingPaymentSettlement" class="mobile-btn mobile-btn-primary" to="/mobile/orders">查看我的订单</RouterLink>
          </template>
        </div>
      </template>
    </div>
  </main>

  <Teleport to="body">
    <div v-if="servicePanelVisible" class="service-panel-mask" @click.self="servicePanelVisible = false">
      <section class="service-panel" role="dialog" aria-modal="true" aria-labelledby="order-service-title">
        <header>
          <span class="mobile-eyebrow">Customer Service</span>
          <h2 id="order-service-title">官方客服</h2>
        </header>

        <div v-if="pageLoading" class="service-loading">正在读取客服信息...</div>
        <template v-else-if="productConfig.customerServiceQrCode || productConfig.email">
          <figure v-if="productConfig.customerServiceQrCode">
            <img :src="productConfig.customerServiceQrCode" alt="客服微信二维码" />
            <figcaption>扫码添加微信客服</figcaption>
          </figure>
          <a v-if="productConfig.email" class="service-mail" :href="`mailto:${productConfig.email}`">
            <span>联系邮箱</span>
            <strong>{{ productConfig.email }}</strong>
          </a>
        </template>
        <p v-else class="service-loading">客服信息暂未配置，请稍后再试。</p>

        <button class="mobile-btn mobile-btn-ghost" type="button" @click="servicePanelVisible = false">关闭</button>
      </section>
    </div>
  </Teleport>

  <ContractPreviewDialog
    :open="contractPreviewVisible"
    :preview="contractPreviewData"
    :loading="contractDraftPreviewLoading"
    :error="contractDraftPreviewError"
    :downloading="Boolean(contractDraftDownloadingId)"
    variant="mobile"
    template-mode
    @close="contractPreviewVisible = false"
    @retry="openContractDraftPreview(contractPreviewTemplate)"
    @download="downloadContractDraft(contractPreviewTemplate)"
  />
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showToast } from 'vant'
import ContractPreviewDialog from '@/components/ContractPreviewDialog.vue'
import OrderContractsPanel from '@/components/OrderContractsPanel.vue'
import { isMobileDevice } from '@/device/platform'
import { getProductAgreements, hasCompleteProductAgreements, buildAcceptedAgreements } from '@/utils/productAgreements'
import {
  createWebsiteAlipayPay,
  createWebsiteOrder,
  getWebsiteAddresses,
  getWebsiteOrder,
  getWebsiteOrders,
  getWebsiteProductConfig,
  getWebsiteProducts,
  getWebsiteCityPartnerRegions,
  getWebsiteCityPartnerContractDraft,
  downloadWebsiteCityPartnerContractDraft,
  previewWebsiteCityPartnerContractDraft,
  reviseWebsiteOrder,
  submitWebsiteBankTransfer,
  uploadWebsitePaymentVoucher
} from '@/api/trade'
import {
  isCityPartnerProduct,
  normalizePaymentMethods,
  paymentMethodText
} from '@/composables/useWebsiteProductConfig'
import { cityPartnerEnterpriseSnapshot, hasCityPartnerContract } from '@/utils/orderContracts'

const route = useRoute()
const router = useRouter()
const pageLoading = ref(true)
const pageMessage = ref('')
const loading = ref(false)
const step = ref('agreement')
const formError = ref('')
const tradeMessage = ref('')
const addresses = ref([])
const selectedAddressId = ref('')
const sameServiceContact = ref(true)
const acceptedKeys = ref([])
const acceptedContractIds = ref([])
const contractTemplates = ref([])
const contractDraftLoading = ref(false)
const contractDraftMessage = ref('')
const contractDraftError = ref(false)
const contractDraftDownloadingId = ref('')
const contractPreviewVisible = ref(false)
const contractPreviewData = ref(null)
const contractDraftPreviewLoading = ref(false)
const contractDraftPreviewError = ref('')
const contractPreviewTemplate = ref(null)
const provinceOptions = ref([])
const currentOrder = ref(null)
const revisingOrderId = ref('')
const payMethod = ref('ALIPAY')
const paymentOpened = ref(false)
const paymentCheckLoading = ref(false)
const paymentVoucher = ref(null)
const paymentVoucherInput = ref(null)
const paymentVoucherUploading = ref(false)
const paymentVoucherMessage = ref('')
const servicePanelVisible = ref(false)
let idempotencyKey = ''
let areaPromise = null
let pollTimer = null
let pollCount = 0
const tradeProducts = ref([])
const selectedProductCode = ref('')
const cityPartnerRegions = ref([])
const cityRegionLoading = ref(false)
const cityRegionMessage = ref('')
const cityPartnerProvinceOptions = ref([])
const cityPartnerSelection = reactive({
  provinceCode: '',
  cityCode: ''
})
let cityRegionRequestId = 0
let contractDraftRequestId = 0

const productConfig = ref({
  orderEnabled: false,
  priceHidden: true,
  bankTransferEnabled: false,
  email: ''
})
const orderForm = reactive({
  productCode: '',
  cityPartnerRequest: {
    regionCode: '',
    regionName: '',
    contractMailingAddress: ''
  },
  addressId: '',
  userPhone: localStorage.getItem('dzzj_website_phone') || '',
  userNickname: '',
  quantity: 1,
  receiverName: '',
  receiverPhone: localStorage.getItem('dzzj_website_phone') || '',
  province: '',
  city: '',
  district: '',
  addressDetail: '',
  serviceContact: '',
  servicePhone: localStorage.getItem('dzzj_website_phone') || '',
  remark: ''
})

const selectedProduct = computed(() => tradeProducts.value.find(
  product => product.productCode === selectedProductCode.value
) || null)
const isCityPartnerPackage = computed(() => isCityPartnerProduct(selectedProduct.value))
const selectedProductNeedDelivery = computed(() => productNeedDelivery(selectedProduct.value))
const canCreateOrder = computed(() => productConfig.value.orderEnabled === true && Boolean(selectedProduct.value))
const contractContextKey = computed(() => JSON.stringify({
  productCode: selectedProduct.value?.productCode || '',
  cityPartnerRequest: buildCityPartnerRequest()
}))
/** 规范购买数量，城市合伙人固定为 1，其他商品至少为 1。 */
const orderQuantity = computed(() => {
  if (isCityPartnerPackage.value) return 1
  const quantity = Math.floor(Number(orderForm.quantity))
  return Number.isFinite(quantity) && quantity >= 1 ? quantity : 1
})
const priceLabel = computed(() => Number(productConfig.value.priceHidden) || !selectedProduct.value
  ? '价格以确认订单为准'
  : money(selectedProduct.value.unitPrice))
const totalLabel = computed(() => Number(productConfig.value.priceHidden) || !selectedProduct.value
  ? '价格咨询客服'
  : money(Number(selectedProduct.value.unitPrice || 0) * orderQuantity.value + Number(selectedProduct.value.freightAmount || 0)))
const cityOptions = computed(() => provinceOptions.value.find(item => item.value === orderForm.province)?.children || [])
const districtOptions = computed(() => cityOptions.value.find(item => item.value === orderForm.city)?.children || [])
const cityPartnerCityOptions = computed(() => cityPartnerProvinceOptions.value.find(
  item => item.value === cityPartnerSelection.provinceCode
)?.children || [])
const cityPartnerRegionOptions = computed(() => {
  const selectedRegionCode = orderForm.cityPartnerRequest.regionCode
  const exists = cityPartnerRegions.value.some(item => item.regionCode === selectedRegionCode)
  if (exists || !selectedRegionCode) return cityPartnerRegions.value
  return [
    ...cityPartnerRegions.value,
    {
      regionCode: selectedRegionCode,
      regionName: regionDisplayName(selectedRegionCode, orderForm.cityPartnerRequest.regionName)
    }
  ]
})
const agreements = computed(() => normalizeAgreements(selectedProduct.value))
const productAgreementsReady = computed(() => hasCompleteProductAgreements(selectedProduct.value, agreements.value))
const agreementsAccepted = computed(() => productAgreementsReady.value
  && agreements.value.every(item => acceptedKeys.value.includes(item.confirmationKey)))
/** 仅在当前合同加载完成且逐项确认全部模板后允许城市合伙人建单。 */
const contractsAccepted = computed(() => {
  if (!isCityPartnerPackage.value) return true
  return !contractDraftLoading.value && contractTemplates.value.length > 0
    && contractTemplates.value.every(template => acceptedContractIds.value.includes(template.id))
})
const allAccepted = computed(() => agreementsAccepted.value && contractsAccepted.value)
const canPay = computed(() => canContinuePay(currentOrder.value))
const isRevisingOrder = computed(() => Boolean(revisingOrderId.value))
/** 按当前商品配置取得允许收款方式，历史商品缺失时回退订单快照。 */
const orderAllowedPaymentMethods = computed(() => {
  const productMethods = normalizePaymentMethods(selectedProduct.value?.allowedPaymentMethods)
  if (productMethods.length) return productMethods
  return normalizePaymentMethods(currentOrder.value?.allowedPaymentMethods)
})
const alipayAvailable = computed(() => orderAllowedPaymentMethods.value.includes('ALIPAY'))
const bankTransferAvailable = computed(() => productConfig.value.bankTransferEnabled === true
  && Boolean(productConfig.value.bankName && productConfig.value.bankAccountName && productConfig.value.bankAccountNumber)
  && orderAllowedPaymentMethods.value.includes('BANK_TRANSFER'))
const visiblePaymentMethods = computed(() => orderAllowedPaymentMethods.value.filter(method => method === 'ALIPAY'
  ? alipayAvailable.value
  : method === 'BANK_TRANSFER' && bankTransferAvailable.value))
const bankPending = computed(() => Number(currentOrder.value?.bankTransferStatus) === 1)
const showPaymentContracts = computed(() => hasCityPartnerContract(currentOrder.value)
  && (Number(currentOrder.value?.payStatus) === 1 || bankPending.value))
const awaitingPaymentSettlement = computed(() => canPay.value || bankPending.value)
const bankAccountDetails = computed(() => parseSnapshot(currentOrder.value?.bankTransferAccountSnapshot) || productConfig.value)
const paymentVoucherView = computed(() => {
  if (paymentVoucher.value) return paymentVoucher.value
  const remoteUrl = String(currentOrder.value?.bankTransferVoucher || '').trim()
  if (!remoteUrl) return null
  const remoteName = currentOrder.value?.bankTransferVoucherName || '已上传支付凭证'
  return { url: remoteUrl, previewUrl: remoteUrl, filename: remoteName }
})
const effectivePaymentVoucherUrl = computed(() => paymentVoucher.value?.url
  || String(currentOrder.value?.bankTransferVoucher || '').trim())
const orderAmount = computed(() => {
  if (!currentOrder.value) return totalLabel.value
  if (Number(productConfig.value.priceHidden)) return '以订单金额为准'
  return money(currentOrder.value.payAmount || currentOrder.value.totalAmount)
})
const payTitle = computed(() => {
  if (!currentOrder.value) return '确认订单与支付'
  if (bankPending.value) return '转账待核对'
  if (Number(currentOrder.value.payStatus) === 1) return '支付成功'
  if (Number(currentOrder.value.orderStatus) === 7) return '订单已关闭'
  return '确认订单与支付'
})
const payHint = computed(() => {
  const order = currentOrder.value
  if (!order) return '正在读取当前订单状态。'
  if (bankPending.value) return '转账信息已提交，合同已生成。可在下方在线预览或下载合同，后台核对到账后订单将进入审核。'
  if (Number(order.bankTransferStatus) === 3) return order.bankTransferReviewRemark || '上次转账核对未通过，请确认到账后重新提交。'
  if (canPay.value && !visiblePaymentMethods.value.length) return '当前商品未配置可用收款方式，请联系客服。'
  if (canPay.value) return payMethod.value === 'BANK_TRANSFER' ? '请按账户信息转账并备注订单号。' : '核对金额后将打开支付宝完成支付。'
  if (hasCityPartnerContract(order) && Number(order.payStatus) === 1) {
    return '支付成功，合同已进入签署流程。请在线预览、下载或查收合同，完成签字盖章并寄回；订单/支付审核通过后权益正式生效。'
  }
  if (Number(order.payStatus) === 1) return '订单已支付，请等待后台审核。'
  return '当前订单状态不能继续支付。'
})
const payStatusText = computed(() => {
  if (bankPending.value) return '转账待核对'
  if (Number(currentOrder.value?.bankTransferStatus) === 3) return '转账核对未通过'
  return Number(currentOrder.value?.payStatus) === 1 ? '已支付' : '未支付'
})

function money(value) {
  return `¥${Number(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

/**
 * 按 PC 的发货标识规则判断商品是否需要收货信息。
 * @param {object|null} product 官网商品
 * @returns {boolean} false 或数值化后为 0 时无需发货
 */
function productNeedDelivery(product) {
  return !(product?.needDelivery === false || Number(product?.needDelivery ?? 0) === 0)
}

/**
 * 规范官网商品数据。
 * @param product 后端商品
 * @returns {object} 前端商品对象
 */
function normalizeTradeProduct(product) {
  const includes = Array.isArray(product?.includesList)
    ? product.includesList
    : String(product?.includesText || '').split(/\r?\n/).map(item => item.trim()).filter(Boolean)
  return {
    ...product,
    needDelivery: productNeedDelivery(product),
    includesList: includes,
    cooperationCondition: String(product?.cooperationCondition || '').trim(),
    allowedPaymentMethods: normalizePaymentMethods(
      product?.allowedPaymentMethods?.length ? product.allowedPaymentMethods : product?.paymentMethods
    )
  }
}

/**
 * 按省市查询城市合伙人可选空闲区县。
 * @returns {Promise<void>} 查询结果
 */
async function loadCityPartnerRegions() {
  const { provinceCode, cityCode } = cityPartnerSelection
  if (!provinceCode || !cityCode) {
    cityPartnerRegions.value = []
    cityRegionMessage.value = ''
    return
  }
  const requestId = ++cityRegionRequestId
  cityRegionLoading.value = true
  cityRegionMessage.value = ''
  try {
    const result = await getWebsiteCityPartnerRegions({ provinceCode, cityCode, current: 1, size: 200 })
    if (requestId !== cityRegionRequestId) return
    cityPartnerRegions.value = Array.isArray(result) ? result : result?.records || []
    if (!cityPartnerRegions.value.length) {
      cityRegionMessage.value = '当前城市暂无空闲合作区域，请更换城市或联系客服。'
    }
  } catch (error) {
    if (requestId !== cityRegionRequestId) return
    cityPartnerRegions.value = []
    cityRegionMessage.value = error.message || '空闲合作区域加载失败。'
  } finally {
    if (requestId === cityRegionRequestId) cityRegionLoading.value = false
  }
}

/**
 * 清空区县选择并作废旧的合作区域请求。
 * @returns {void} 保留其余已填写信息
 */
function resetCityPartnerRegion() {
  cityRegionRequestId += 1
  cityRegionLoading.value = false
  cityPartnerRegions.value = []
  cityRegionMessage.value = ''
  orderForm.cityPartnerRequest.regionCode = ''
  orderForm.cityPartnerRequest.regionName = ''
  resetContractDraft()
}

/** 切换合作省份并清空城市、区县。 */
function changeCityPartnerProvince() {
  cityPartnerSelection.cityCode = ''
  resetCityPartnerRegion()
}

/** 切换合作城市并重新加载空闲区县。 */
function changeCityPartnerCity() {
  resetCityPartnerRegion()
  loadCityPartnerRegions()
}

/**
 * 从区县编码推导省市编码。
 * @param {string|number} regionCode 区县行政区划编码
 * @returns {{provinceCode:string,cityCode:string}} 省市编码
 */
function deriveCityPartnerAreaCodes(regionCode) {
  const code = String(regionCode || '')
  return {
    provinceCode: code.slice(0, 2).padEnd(6, '0'),
    cityCode: code.slice(0, 4).padEnd(6, '0')
  }
}

/**
 * 回显订单既有合作区域并加载同级空闲区县。
 * @param {object} order 官网订单
 * @returns {Promise<void>} 回显结果
 */
async function restoreCityPartnerRegionFromOrder(order) {
  const regionCode = String(order?.cityPartnerRegionCode || '').trim()
  if (!regionCode) return
  await loadArea()
  cityPartnerSelection.provinceCode = deriveCityPartnerAreaCodes(regionCode).provinceCode
  cityPartnerSelection.cityCode = deriveCityPartnerAreaCodes(regionCode).cityCode
  const enterpriseSnapshot = cityPartnerEnterpriseSnapshot(order)
  orderForm.cityPartnerRequest = {
    regionCode,
    regionName: order.cityPartnerRegionName || orderForm.cityPartnerRequest.regionName || '',
    contractMailingAddress: enterpriseSnapshot.contractMailingAddress
      || orderForm.cityPartnerRequest.contractMailingAddress || ''
  }
  await loadCityPartnerRegions()
}

/**
 * 在当前省市区编码树中查找选项。
 * @param {Array<object>} options 可选区域列表
 * @param {string} value 编码或历史名称
 * @returns {object|null} 匹配的区域选项
 */
function findAreaOption(options, value) {
  return (options || []).find(item => item.value === value || item.label === value) || null
}

/**
 * 将历史省市区名称数据转换为行政区划编码。
 * @param {object} address 地址对象
 * @returns {{province:string,city:string,district:string}} 行政区划编码
 */
function normalizeAddressCodes(address) {
  const province = findAreaOption(provinceOptions.value, String(address?.province || ''))
  const city = findAreaOption(province?.children || [], String(address?.city || ''))
  const district = findAreaOption(city?.children || [], String(address?.district || ''))
  return {
    province: province?.value || '',
    city: city?.value || '',
    district: district?.value || ''
  }
}

/**
 * 格式化收货地址，编码仅用于提交，页面只展示名称。
 * @param {object} item 地址或订单对象
 * @returns {string} 省市区名称加详细地址
 */
function fullAddress(item) {
  const province = findAreaOption(provinceOptions.value, String(item?.province || ''))
  const city = findAreaOption(province?.children || [], String(item?.city || ''))
  const district = findAreaOption(city?.children || [], String(item?.district || ''))
  const areaName = (option, fallback) => {
    if (option?.label && option.label !== '市辖区') return option.label
    return fallback && !/^\d{6}$/.test(fallback) ? fallback : ''
  }
  return [
    areaName(province, item?.province),
    areaName(city, item?.city),
    areaName(district, item?.district),
    item?.addressDetail
  ].filter(Boolean).join('')
}

/**
 * 根据县级行政区划编码生成完整区域名称。
 * @param {string} regionCode 县级行政区划编码
 * @param {string} fallbackName 后端区域名称快照
 * @returns {string} 省/市/区名称
 */
function regionDisplayName(regionCode, fallbackName = '') {
  for (const province of provinceOptions.value) {
    for (const city of province.children || []) {
      const district = (city.children || []).find(item => item.value === regionCode)
      if (district) {
        return [province.label, city.label, district.label].filter(label => label && label !== '市辖区').join(' / ')
      }
    }
  }
  return fallbackName || ''
}

function canContinuePay(order) {
  return Boolean(order) && Number(order.payStatus) === 0 && Number(order.orderStatus) === 1 && Number(order.bankTransferStatus) !== 1
}

/**
 * 判断订单是否处于后台审核需要修改后的用户重提状态。
 * @param {object} order 官网订单
 * @returns {boolean} 是否可修改后重新提交
 */
function canReviseOrder(order) {
  return Boolean(order) && Number(order.payStatus) === 1 && Number(order.orderStatus) === 2
    && Number(order.orderAuditStatus) === 3
}

function normalizeOrderId(value) {
  const segments = String(value || '').split(/[/?&]/).filter(Boolean)
  const candidate = segments[segments.length - 1] || ''
  return /^\d+$/.test(candidate) ? candidate : ''
}

function parseSnapshot(value) {
  if (!value) return null
  if (typeof value === 'object') return value
  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch {
    return null
  }
}

/**
 * 仅展示当前商品配置的已发布协议，保留版本及确认标识。
 * @param {object|null} product 当前商品
 * @returns {Array<object>} 可阅读的商品协议
 */
function normalizeAgreements(product) {
  return getProductAgreements(product).map((item, index) => {
    const title = String(item?.title || item?.agreementTitle || item?.name || `订购协议 ${index + 1}`).trim()
    const content = item?.content || item?.template || item?.agreementTemplate || item?.text || ''
    return { ...item, title, html: normalizeHtml(content) }
  }).filter(item => item.title && item.html)
}

function normalizeHtml(value) {
  const content = String(value || '').trim()
  if (!content) return ''
  const raw = /<\/?[a-z][\s\S]*>/i.test(content) ? content : content.split(/\r?\n/).map(line => `<p>${escapeHtml(line)}</p>`).join('')
  const template = document.createElement('template')
  template.innerHTML = raw
  template.content.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach(node => node.remove())
  template.content.querySelectorAll('*').forEach(node => {
    Array.from(node.attributes).forEach(attribute => {
      const name = attribute.name.toLowerCase()
      if (name.startsWith('on') || attribute.value.trim().toLowerCase().startsWith('javascript:')) node.removeAttribute(attribute.name)
    })
  })
  return template.innerHTML
}

function escapeHtml(value) {
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
}

/**
 * 仅在需发货且选择同收货人时同步服务联系人。
 * @returns {void} 无需发货时保留独立填写的服务信息
 */
function syncServiceContact() {
  if (!selectedProductNeedDelivery.value || !sameServiceContact.value) return
  orderForm.serviceContact = orderForm.receiverName
  orderForm.servicePhone = orderForm.receiverPhone
}

/**
 * 清空无需发货商品的收货字段，禁止清空或覆盖服务联系人。
 * @returns {void} 同步关闭“与收货人相同”选项
 */
function normalizeNoDeliveryForm() {
  if (selectedProductNeedDelivery.value) return
  sameServiceContact.value = false
  selectedAddressId.value = ''
  orderForm.addressId = ''
  orderForm.receiverName = ''
  orderForm.receiverPhone = ''
  orderForm.province = ''
  orderForm.city = ''
  orderForm.district = ''
  orderForm.addressDetail = ''
}

/**
 * 仅为需发货且尚未填写地址的订单表单套用默认地址。
 * @returns {void} 不覆盖用户已填写的地址或独立服务联系人
 */
function maybeApplyDefaultAddress() {
  if (!selectedProductNeedDelivery.value || step.value !== 'form' || selectedAddressId.value) return
  if (orderForm.receiverName || orderForm.province || orderForm.city || orderForm.district || orderForm.addressDetail) return
  const address = addresses.value.find(item => Number(item.defaultFlag) === 1) || addresses.value[0]
  if (!address?.id) return
  selectedAddressId.value = String(address.id)
  applyAddress()
}

/**
 * 调整非城市合伙人套餐的购买数量。
 * @param {number} delta 调整幅度
 * @returns {void} 提交中或已有订单时不再变更
 */
function changeQuantity(delta) {
  if (loading.value || currentOrder.value || isCityPartnerPackage.value) return
  orderForm.quantity = Math.max(1, orderQuantity.value + delta)
}

/**
 * 切换商品后重新确认协议，作废旧合同请求并保留仍适用的表单输入。
 * @param {string} productCode 商品编码
 * @returns {void} 已建单或提交中不允许切换商品
 */
function selectProduct(productCode) {
  if (loading.value || currentOrder.value || String(productCode || '') === orderForm.productCode) return
  syncServiceContact()
  selectedProductCode.value = String(productCode || '')
  orderForm.productCode = selectedProductCode.value
  orderForm.quantity = 1
  cityPartnerSelection.provinceCode = ''
  cityPartnerSelection.cityCode = ''
  resetCityPartnerRegion()
  acceptedKeys.value = []
  idempotencyKey = ''
  formError.value = ''
  tradeMessage.value = ''
  normalizeNoDeliveryForm()
  step.value = 'agreement'
}

/**
 * 同步所选合作区域名称。
 */
function syncCityRegionName() {
  const region = cityPartnerRegionOptions.value.find(item => item.regionCode === orderForm.cityPartnerRequest.regionCode)
  const regionCode = orderForm.cityPartnerRequest.regionCode
  orderForm.cityPartnerRequest.regionName = region?.regionName
    || (regionCode ? regionDisplayName(regionCode, orderForm.cityPartnerRequest.regionName) : '')
}

function changeProvince() {
  orderForm.city = ''
  orderForm.district = ''
  selectedAddressId.value = ''
  orderForm.addressId = ''
}

function changeCity() {
  orderForm.district = ''
  selectedAddressId.value = ''
  orderForm.addressId = ''
}

/**
 * 套用当前选择的收货地址，并在启用同步时更新服务联系人。
 * @returns {void} 无需发货商品不读取或套用任何地址
 */
function applyAddress() {
  if (!selectedProductNeedDelivery.value) {
    normalizeNoDeliveryForm()
    return
  }
  const address = addresses.value.find(item => String(item.id) === selectedAddressId.value)
  if (!address) {
    orderForm.addressId = ''
    return
  }
  Object.assign(orderForm, {
    addressId: address.id,
    receiverName: address.receiverName || '',
    receiverPhone: address.receiverPhone || '',
    ...normalizeAddressCodes(address),
    addressDetail: address.addressDetail || ''
  })
  syncServiceContact()
}

/**
 * 校验订单与所选商品必填信息。
 * @returns {boolean} 是否通过校验
 */
function validateForm() {
  normalizeNoDeliveryForm()
  syncServiceContact()
  const deliveryRules = selectedProductNeedDelivery.value
    ? [
        ['receiverName', '请填写收货人'],
        ['receiverPhone', '请填写联系电话'],
        ['province', '请选择省份'],
        ['city', '请选择城市'],
        ['district', '请选择区县'],
        ['addressDetail', '请填写详细地址']
      ]
    : []
  const rules = [
    ...deliveryRules,
    ['serviceContact', '请填写服务联系人'],
    ['servicePhone', '请填写服务电话']
  ]
  for (const [field, message] of rules) {
    if (!String(orderForm[field] || '').trim()) {
      formError.value = message
      focusField(field)
      return false
    }
  }
  if (!selectedProduct.value) {
    formError.value = '请选择购买商品'
    focusField('productCode')
    return false
  }
  if (isCityPartnerPackage.value && !String(orderForm.cityPartnerRequest.regionCode || '').trim()) {
    formError.value = '请选择空闲合作区域'
    focusField(!cityPartnerSelection.provinceCode ? 'cityPartnerSelection.provinceCode'
      : !cityPartnerSelection.cityCode ? 'cityPartnerSelection.cityCode' : 'cityPartnerRequest.regionCode')
    return false
  }
  if (isCityPartnerPackage.value && !String(orderForm.cityPartnerRequest.contractMailingAddress || '').trim()) {
    formError.value = '请填写合同邮寄地址'
    focusField('cityPartnerRequest.contractMailingAddress')
    return false
  }
  if (selectedProductNeedDelivery.value && !/^1[3-9]\d{9}$/.test(String(orderForm.receiverPhone).trim())) {
    formError.value = '收货电话格式不正确'
    focusField('receiverPhone')
    return false
  }
  if (!/^1[3-9]\d{9}$/.test(String(orderForm.servicePhone).trim())) {
    formError.value = '服务电话格式不正确'
    focusField('servicePhone')
    return false
  }
  formError.value = ''
  return true
}

/**
 * 待表单渲染后滚动到错误字段，隐藏的同步服务字段定位到对应收货人字段。
 * @param {string} field 表单字段名
 * @returns {void} 安排错误输入框聚焦
 */
function focusField(field) {
  const target = selectedProductNeedDelivery.value && sameServiceContact.value
    ? { serviceContact: 'receiverName', servicePhone: 'receiverPhone' }[field] || field
    : field
  window.setTimeout(() => {
    const input = document.querySelector(`[data-order-field="${target}"]`)
    input?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    input?.focus({ preventScroll: true })
  }, 100)
}

/**
 * 校验当前商品与官网下单开关，所有新订单入口共用此保护。
 * @returns {boolean} 是否允许继续新订单流程
 */
function checkCheckoutAvailable() {
  if (!canCreateOrder.value) {
    tradeMessage.value = selectedProduct.value ? '当前暂未开放下单' : '商品不存在或已停用'
    return false
  }
  return true
}

/**
 * 确认全部订购协议后进入表单，收货地址只在需发货时自动填充。
 * @returns {void} 不创建订单或发起支付
 */
function agreeAndGoToForm() {
  if (loading.value) return
  if (currentOrder.value) {
    step.value = 'pay'
    return
  }
  if (!checkCheckoutAvailable()) return
  if (!agreementsAccepted.value) {
    tradeMessage.value = '请阅读并勾选全部协议后继续。'
    return
  }
  tradeMessage.value = ''
  step.value = 'form'
  normalizeNoDeliveryForm()
  maybeApplyDefaultAddress()
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/**
 * 从表单返回协议，保留输入并作废未完成的合同确认。
 * @returns {void} 提交中或已建单时不回退
 */
function goBackToAgreement() {
  if (loading.value || currentOrder.value) return
  resetContractDraft()
  tradeMessage.value = ''
  step.value = 'agreement'
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/**
 * 从合同返回表单，保留输入并要求修改后重新加载、确认合同。
 * @returns {void} 提交中或已建单时不回退
 */
function goBackToForm() {
  if (loading.value || currentOrder.value) return
  resetContractDraft()
  tradeMessage.value = ''
  step.value = 'form'
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/**
 * 全量校验表单与协议；普通商品直接建单，城市合伙人进入独立合同步骤。
 * @returns {Promise<void>} 表单提交或合同加载结果
 */
async function submitOrderForm() {
  if (loading.value || contractDraftLoading.value) return
  if (currentOrder.value) {
    if (isRevisingOrder.value) await submitOrderRevision()
    return
  }
  if (!isRevisingOrder.value && !canCreateOrder.value) {
    tradeMessage.value = '当前暂未开放下单，请稍后再试。'
    step.value = 'pay'
    return
  }
  if (!checkCheckoutAvailable()) return
  if (!validateForm()) {
    step.value = 'form'
    return
  }
  if (!isRevisingOrder.value && !agreementsAccepted.value) {
    step.value = 'agreement'
    tradeMessage.value = '请先返回第一步确认全部订购协议。'
    return
  }
  tradeMessage.value = ''
  if (!isRevisingOrder.value && !isCityPartnerPackage.value) {
    await createOrder()
    return
  }
  step.value = 'contract'
  window.scrollTo({ top: 0, behavior: 'smooth' })
  await loadContractDraft()
}

/**
 * 从订单详情进入审核修改流程，回显原订单的商品、地址、服务与合作区域信息。
 * @param {object} order 需要修改的官网订单
 * @returns {Promise<void>} 回显结果
 */
async function startOrderRevision(order) {
  if (!canReviseOrder(order)) {
    tradeMessage.value = '当前订单不需要修改，不能进入修改流程。'
    step.value = 'pay'
    return
  }
  currentOrder.value = order
  revisingOrderId.value = order.id
  selectedAddressId.value = ''
  acceptedContractIds.value = []
  resetContractDraft()
  Object.assign(orderForm, {
    productCode: order.productCode || '',
    userPhone: order.userPhone || orderForm.userPhone,
    userNickname: order.userNickname || orderForm.userNickname,
    quantity: Number(order.quantity) || 1,
    receiverName: order.receiverName || '',
    receiverPhone: order.receiverPhone || '',
    province: order.province || '',
    city: order.city || '',
    district: order.district || '',
    addressDetail: order.addressDetail || '',
    serviceContact: order.serviceContact || '',
    servicePhone: order.servicePhone || '',
    remark: order.remark || ''
  })
  selectedProductCode.value = order.productCode || selectedProductCode.value
  if (selectedProductNeedDelivery.value || isCityPartnerPackage.value) await loadArea()
  if (selectedProductNeedDelivery.value) Object.assign(orderForm, normalizeAddressCodes(orderForm))
  sameServiceContact.value = orderForm.receiverName === orderForm.serviceContact
    && orderForm.receiverPhone === orderForm.servicePhone
  if (isCityPartnerPackage.value) await restoreCityPartnerRegionFromOrder(order)
  normalizeNoDeliveryForm()
  formError.value = ''
  tradeMessage.value = '请按后台审核意见修改订单信息后重新提交。'
  step.value = 'form'
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

/**
 * 取消修改并返回订单详情。
 */
function cancelOrderRevision() {
  if (loading.value || !currentOrder.value) return
  revisingOrderId.value = ''
  resetContractDraft()
  formError.value = ''
  tradeMessage.value = ''
  router.replace(`/mobile/orders/${currentOrder.value.id}`)
}

/**
 * 提交审核需要修改订单的新信息，并返回订单详情等待再次审核。
 * @returns {Promise<void>} 提交结果
 */
async function submitOrderRevision() {
  if (loading.value || !isRevisingOrder.value) return
  if (!canReviseOrder(currentOrder.value)) {
    tradeMessage.value = '订单状态已变化，请刷新后重试。'
    return
  }
  if (!validateForm()) return
  loading.value = true
  tradeMessage.value = ''
  try {
    const order = await reviseWebsiteOrder(revisingOrderId.value, buildOrderPayload())
    currentOrder.value = order
    revisingOrderId.value = ''
    acceptedKeys.value = []
    acceptedContractIds.value = []
    resetContractDraft()
    tradeMessage.value = '订单信息已重新提交，等待后台审核。'
    await router.replace(`/mobile/orders/${order.id}`)
  } catch (error) {
    tradeMessage.value = error.message || '订单修改提交失败，请稍后重试'
  } finally {
    loading.value = false
  }
}

/**
 * 作废当前合同、预览和下载请求，清空与旧商品或旧表单绑定的确认。
 * @returns {void} 已填写表单保持不变
 */
function resetContractDraft() {
  contractDraftRequestId += 1
  contractTemplates.value = []
  acceptedContractIds.value = []
  contractDraftLoading.value = false
  contractDraftMessage.value = ''
  contractDraftError.value = false
  contractDraftDownloadingId.value = ''
  contractPreviewVisible.value = false
  contractPreviewTemplate.value = null
  contractPreviewData.value = null
  contractDraftPreviewLoading.value = false
  contractDraftPreviewError.value = ''
}

/**
 * 检查异步合同结果是否仍属于当前未提交的商品与表单。
 * @param {number} requestId 发起请求时的合同版本
 * @param {string} contextKey 发起请求时的商品与合作信息快照
 * @returns {boolean} 是否允许写回页面或触发下载
 */
function isCurrentContractRequest(requestId, contextKey) {
  return requestId === contractDraftRequestId && contextKey === contractContextKey.value
    && isCityPartnerPackage.value && !currentOrder.value
}

/**
 * 加载当前城市合伙人草稿匹配到的全部合同模板，重试需重新逐项确认。
 * @returns {Promise<void>} 加载结果
 */
async function loadContractDraft() {
  if (!isCityPartnerPackage.value || currentOrder.value || loading.value || contractDraftLoading.value) return
  syncCityRegionName()
  resetContractDraft()
  const requestId = contractDraftRequestId
  const contextKey = contractContextKey.value
  contractDraftLoading.value = true
  try {
    const templates = await getWebsiteCityPartnerContractDraft(
      selectedProduct.value?.productCode,
      buildCityPartnerRequest()
    )
    if (!isCurrentContractRequest(requestId, contextKey)) return
    contractTemplates.value = Array.isArray(templates) ? templates : []
    if (!contractTemplates.value.length) {
      contractDraftMessage.value = '城市合伙人合同模板未配置或未启用，请联系客服。'
      contractDraftError.value = true
    }
  } catch (error) {
    if (!isCurrentContractRequest(requestId, contextKey)) return
    contractTemplates.value = []
    acceptedContractIds.value = []
    contractDraftMessage.value = error.message || '合同信息加载失败，请稍后重试。'
    contractDraftError.value = true
  } finally {
    if (isCurrentContractRequest(requestId, contextKey)) contractDraftLoading.value = false
  }
}

/**
 * 下载去除占位符后的城市合伙人合同模板。
 * @param {object} template 合同模板
 * @returns {Promise<void>} 下载结果
 */
async function downloadContractDraft(template) {
  if (!template?.id || contractDraftDownloadingId.value || currentOrder.value
    || !contractTemplates.value.some(item => item.id === template.id)) return
  syncCityRegionName()
  const requestId = contractDraftRequestId
  const contextKey = contractContextKey.value
  contractDraftDownloadingId.value = template.id
  contractDraftMessage.value = ''
  contractDraftError.value = false
  try {
    const { blob, filename } = await downloadWebsiteCityPartnerContractDraft(
      template.id,
      selectedProduct.value?.productCode,
      buildCityPartnerRequest()
    )
    if (!isCurrentContractRequest(requestId, contextKey)) return
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename || `${template.templateName}-模板.docx`
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
    URL.revokeObjectURL(url)
  } catch (error) {
    if (!isCurrentContractRequest(requestId, contextKey)) return
    contractDraftMessage.value = error.message || '合同预览下载失败，请稍后重试。'
    contractDraftError.value = true
  } finally {
    if (isCurrentContractRequest(requestId, contextKey)) contractDraftDownloadingId.value = ''
  }
}

/**
 * 打开下单前城市合伙人合同模板的HTML在线预览。
 * @param {object} template 合同模板
 * @returns {Promise<void>} 预览结果
 */
async function openContractDraftPreview(template) {
  if (!template?.id || contractDraftPreviewLoading.value || currentOrder.value
    || !contractTemplates.value.some(item => item.id === template.id)) return
  syncCityRegionName()
  const requestId = contractDraftRequestId
  const contextKey = contractContextKey.value
  contractPreviewTemplate.value = template
  contractPreviewVisible.value = true
  contractPreviewData.value = null
  contractDraftPreviewLoading.value = true
  contractDraftPreviewError.value = ''
  try {
    const preview = await previewWebsiteCityPartnerContractDraft(
      template.id,
      selectedProduct.value?.productCode,
      buildCityPartnerRequest()
    )
    if (!isCurrentContractRequest(requestId, contextKey)) return
    contractPreviewData.value = preview
  } catch (error) {
    if (!isCurrentContractRequest(requestId, contextKey)) return
    contractPreviewData.value = null
    contractDraftPreviewError.value = error.message || '合同预览加载失败，请稍后重试。'
  } finally {
    if (isCurrentContractRequest(requestId, contextKey)) contractDraftPreviewLoading.value = false
  }
}

function getIdempotencyKey() {
  if (idempotencyKey) return idempotencyKey
  idempotencyKey = window.crypto?.randomUUID?.() || `mobile-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`
  return idempotencyKey
}

/**
 * 按 PC 白名单构造城市合伙人信息，不传已停用的企业资料或空格式字段。
 * @param {boolean} withAccepted 是否附带建单时的合同确认标识
 * @returns {object} 合作区域、合同邮寄地址及可选确认标识
 */
function buildCityPartnerRequest(withAccepted = false) {
  const request = orderForm.cityPartnerRequest || {}
  return {
    regionCode: String(request.regionCode || '').trim(),
    regionName: String(request.regionName || '').trim(),
    contractMailingAddress: String(request.contractMailingAddress || '').trim(),
    ...(withAccepted ? { contractAccepted: true } : {})
  }
}

/**
 * 构造服务端计价的订单请求，无需发货时省略整组收货字段以避免空串格式校验。
 * @returns {object} 普通商品或城市合伙人的建单请求
 */
function buildOrderPayload() {
  normalizeNoDeliveryForm()
  syncServiceContact()
  if (isCityPartnerPackage.value) syncCityRegionName()
  return {
    ...orderForm,
    productCode: selectedProduct.value?.productCode,
    acceptedAgreements: isRevisingOrder.value ? undefined
      : buildAcceptedAgreements(agreements.value, acceptedKeys.value),
    quantity: orderQuantity.value,
    userPhone: String(localStorage.getItem('dzzj_website_phone') || orderForm.userPhone || '').trim(),
    userNickname: String(orderForm.receiverName || orderForm.userNickname || '').trim(),
    serviceContact: String(orderForm.serviceContact || '').trim(),
    servicePhone: String(orderForm.servicePhone || '').trim(),
    addressId: selectedProductNeedDelivery.value ? selectedAddressId.value || '' : undefined,
    receiverName: selectedProductNeedDelivery.value ? String(orderForm.receiverName || '').trim() : undefined,
    receiverPhone: selectedProductNeedDelivery.value ? String(orderForm.receiverPhone || '').trim() : undefined,
    province: selectedProductNeedDelivery.value ? orderForm.province : undefined,
    city: selectedProductNeedDelivery.value ? orderForm.city : undefined,
    district: selectedProductNeedDelivery.value ? orderForm.district : undefined,
    addressDetail: selectedProductNeedDelivery.value ? String(orderForm.addressDetail || '').trim() : undefined,
    cityPartnerRequest: isCityPartnerPackage.value ? buildCityPartnerRequest(true) : undefined
  }
}

/**
 * 再次校验开关、表单及协议/合同后创建订单；已有订单只回到支付页，不重复建单。
 * @returns {Promise<void>} 创建结果
 */
async function createOrder() {
  if (loading.value) return
  if (currentOrder.value) {
    step.value = 'pay'
    return
  }
  if (!checkCheckoutAvailable()) return
  if (!agreementsAccepted.value) {
    tradeMessage.value = '请先返回第一步确认全部订购协议。'
    step.value = 'agreement'
    return
  }
  if (!validateForm()) {
    step.value = 'form'
    return
  }
  if (isCityPartnerPackage.value && (step.value !== 'contract' || !contractsAccepted.value)) {
    step.value = 'contract'
    tradeMessage.value = '请阅读并勾选全部城市合伙人合同后继续。'
    if (!contractTemplates.value.length) await loadContractDraft()
    return
  }
  const payload = buildOrderPayload()
  if (isCityPartnerPackage.value && !contractsAccepted.value) {
    tradeMessage.value = '合作信息已更新，请重新确认合同。'
    await loadContractDraft()
    return
  }
  loading.value = true
  tradeMessage.value = ''
  try {
    const order = await createWebsiteOrder(payload, getIdempotencyKey())
    idempotencyKey = ''
    currentOrder.value = order
    acceptedKeys.value = []
    resetContractDraft()
    step.value = 'pay'
    tradeMessage.value = '订单已创建，请完成支付。'
    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (error) {
    tradeMessage.value = error.message || '订单创建失败，请稍后重试'
  } finally {
    loading.value = false
  }
}

/**
 * 发起订单快照允许的支付宝支付。
 * @returns {Promise<void>} 支付发起结果
 */
async function payAlipay() {
  if (loading.value || !canPay.value || payMethod.value !== 'ALIPAY' || !alipayAvailable.value) return
  loading.value = true
  tradeMessage.value = ''
  try {
    const pay = await createWebsiteAlipayPay(currentOrder.value.id, isMobileDevice() ? 'MOBILE' : 'WEB')
    paymentOpened.value = true
    startPolling()
    openAlipay(pay)
    tradeMessage.value = '正在打开支付宝。'
  } catch (error) {
    tradeMessage.value = error.message || '支付宝支付发起失败'
  } finally {
    loading.value = false
  }
}

/**
 * 选择当前订单允许的收款方式。
 * @param method 收款方式编码
 */
function selectPayMethod(method) {
  if (method === 'ALIPAY' && !alipayAvailable.value) return
  if (method === 'BANK_TRANSFER' && !bankTransferAvailable.value) return
  payMethod.value = method
}

function retryAlipay() {
  paymentOpened.value = false
  payAlipay()
}

/** 打开支付凭证文件选择器。 */
function choosePaymentVoucher() {
  if (paymentVoucherUploading.value) return
  paymentVoucherInput.value?.click()
}

/**
 * 校验并上传用户选择的支付凭证。
 * @param {Event} event 文件选择事件
 * @returns {Promise<void>} 上传结果
 */
async function handlePaymentVoucherChange(event) {
  const input = event.target
  const file = input.files?.[0]
  input.value = ''
  if (!file) return
  if (!file.type.startsWith('image/')) {
    paymentVoucherMessage.value = '支付凭证仅支持图片文件'
    return
  }
  if (file.size > 20 * 1024 * 1024) {
    paymentVoucherMessage.value = '支付凭证图片不能超过 20MB'
    return
  }
  const previewUrl = URL.createObjectURL(file)
  revokePaymentVoucherPreview()
  paymentVoucher.value = { file, previewUrl, url: '', filename: file.name }
  paymentVoucherUploading.value = true
  paymentVoucherMessage.value = ''
  try {
    const result = await uploadWebsitePaymentVoucher(file)
    paymentVoucher.value = {
      file,
      previewUrl,
      url: result?.url || '',
      filename: result?.filename || file.name
    }
  } catch (error) {
    paymentVoucherMessage.value = error.message || '支付凭证上传失败，请重新上传。'
  } finally {
    paymentVoucherUploading.value = false
  }
}

/** 释放本地凭证预览地址。 */
function revokePaymentVoucherPreview() {
  if (paymentVoucher.value?.previewUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(paymentVoucher.value.previewUrl)
  }
}

/** 删除本地支付凭证；已提交订单保留后端凭证用于回显。 */
function removePaymentVoucher() {
  if (paymentVoucherUploading.value) return
  revokePaymentVoucherPreview()
  paymentVoucher.value = null
  paymentVoucherMessage.value = ''
}

function openAlipay(pay) {
  if (!pay?.payForm) throw new Error('支付宝支付表单为空')
  if (pay.terminal === 'WEB') {
    const payWindow = window.open('', '_blank')
    if (!payWindow) throw new Error('浏览器已拦截支付页面，请允许弹窗后重试')
    payWindow.document.write(pay.payForm.includes('</body>') ? pay.payForm : `<!doctype html><html><head><meta charset="utf-8"><title>支付宝支付</title></head><body>${pay.payForm}</body></html>`)
    payWindow.document.close()
    return
  }
  if (pay.payUrl) {
    window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(pay.payUrl)}`
    window.setTimeout(() => {
      if (document.visibilityState === 'visible') window.location.href = pay.payUrl
    }, 1200)
    return
  }
  const container = document.createElement('div')
  container.style.display = 'none'
  container.innerHTML = pay.payForm
  document.body.appendChild(container)
  const form = container.querySelector('form')
  if (!form) {
    container.remove()
    throw new Error('支付宝支付表单无效')
  }
  form.submit()
}

/**
 * 提交订单快照允许的转账核对。
 * @returns {Promise<void>} 提交结果
 */
async function submitBankTransfer() {
  if (loading.value || !canPay.value || bankPending.value || payMethod.value !== 'BANK_TRANSFER' || !bankTransferAvailable.value) return
  if (paymentVoucherUploading.value) {
    paymentVoucherMessage.value = '支付凭证上传中，请稍后再提交。'
    return
  }
  if (!effectivePaymentVoucherUrl.value) {
    paymentVoucherMessage.value = '请上传支付凭证'
    return
  }
  loading.value = true
  tradeMessage.value = ''
  try {
    currentOrder.value = await submitWebsiteBankTransfer(
      currentOrder.value.id,
      isMobileDevice() ? 'MOBILE' : 'WEB',
      effectivePaymentVoucherUrl.value
    )
    tradeMessage.value = '转账信息已提交，合同已生成。可在下方在线预览或下载合同，等待后台核对。'
  } catch (error) {
    tradeMessage.value = error.message || '转账核对提交失败'
  } finally {
    loading.value = false
  }
}

function startPolling() {
  stopPolling()
  pollCount = 0
  pollTimer = window.setInterval(async () => {
    pollCount += 1
    if (!currentOrder.value?.id) {
      stopPolling()
      return
    }
    await checkPaymentStatus(false)
    if (pollCount >= 8) {
      stopPolling()
      if (canPay.value && payMethod.value === 'ALIPAY') {
        tradeMessage.value = '暂未查询到支付结果。如支付宝已扣款，请稍后点击检查；未扣款可重新发起支付。'
      }
    }
  }, 3000)
}

function stopPolling() {
  if (pollTimer) window.clearInterval(pollTimer)
  pollTimer = null
}

async function checkPaymentStatus(announce = true) {
  if (paymentCheckLoading.value || !currentOrder.value?.id) return
  paymentCheckLoading.value = true
  try {
    currentOrder.value = await getWebsiteOrder(currentOrder.value.id)
    if (Number(currentOrder.value.payStatus) === 1) {
      stopPolling()
      paymentOpened.value = false
      tradeMessage.value = hasCityPartnerContract(currentOrder.value)
        ? '支付成功，合同已生成。可在下方在线预览、下载或查收合同；订单/支付审核通过后权益正式生效，合同签署进度不影响权益。'
        : '支付已确认，订单已进入后台审核。'
    } else if (!canContinuePay(currentOrder.value)) {
      stopPolling()
      paymentOpened.value = false
      tradeMessage.value = '当前订单状态不能继续支付。'
    } else if (announce) {
      tradeMessage.value = '暂未查询到支付结果。如支付宝已扣款，请稍候几秒后重新检查。'
    }
  } catch (error) {
    if (announce) tradeMessage.value = error.message || '支付结果查询失败，请稍后重试'
  } finally {
    paymentCheckLoading.value = false
  }
}

async function loadArea() {
  if (provinceOptions.value.length) return
  if (!areaPromise) {
    areaPromise = import('@/data/chinaArea')
      .then(module => {
        provinceOptions.value = module.chinaAreaCodeOptions || []
        cityPartnerProvinceOptions.value = module.chinaAreaCodeOptions || []
      })
      .catch(() => {
        areaPromise = null
        pageMessage.value = '地区数据加载失败，请重试。'
      })
  }
  return areaPromise
}

/**
 * 初始化商品、地址、订单与支付信息。
 * @returns {Promise<void>} 初始化结果
 */
async function initialize() {
  if (!localStorage.getItem('dzzj_website_token')) {
    router.replace({ path: '/mobile/login', query: { redirect: route.fullPath } })
    return
  }
  pageLoading.value = true
  pageMessage.value = ''
  const optionalRequestErrors = []
  try {
    const [config, productList, addressList, orderList] = await Promise.all([
      getWebsiteProductConfig(),
      getWebsiteProducts(),
      getWebsiteAddresses().catch(error => {
        optionalRequestErrors.push(error)
        return []
      }),
      getWebsiteOrders().catch(error => {
        optionalRequestErrors.push(error)
        return []
      }),
      loadArea()
    ])
    productConfig.value = { ...productConfig.value, ...(config || {}) }
    tradeProducts.value = (productList || []).map(normalizeTradeProduct)
    addresses.value = addressList || []
    const orderId = normalizeOrderId(route.query.orderId)
    if (route.query.orderId && !orderId) {
      throw new Error('支付回跳订单参数无效，请从我的订单中重新打开。')
    }
    if (orderId) {
      currentOrder.value = await getWebsiteOrder(orderId)
    } else {
      currentOrder.value = (orderList || []).find(item => canContinuePay(item)) || null
    }
    const requestedProductCode = String(route.query.productCode || '').trim()
    selectedProductCode.value = currentOrder.value?.productCode
      || requestedProductCode
      || tradeProducts.value.find(product => product.productCode === orderForm.productCode)?.productCode
      || tradeProducts.value[0]?.productCode
      || ''
    orderForm.productCode = selectedProductCode.value
    normalizeNoDeliveryForm()
    maybeApplyDefaultAddress()
    if (optionalRequestErrors.length) {
      tradeMessage.value = optionalRequestErrors
        .map(error => error.message || '部分下单信息加载失败')
        .join('；')
    }
    if (currentOrder.value && isCityPartnerPackage.value) {
      await restoreCityPartnerRegionFromOrder(currentOrder.value)
    } else if (isCityPartnerPackage.value) {
      await loadArea()
    }
    let revisionStarted = false
    if (orderId && String(route.query.revision || '') === '1' && currentOrder.value) {
      if (canReviseOrder(currentOrder.value)) {
        await startOrderRevision(currentOrder.value)
        revisionStarted = true
        await router.replace({ path: '/mobile/order', query: { orderId: String(orderId) } })
      } else {
        tradeMessage.value = '当前订单不需要修改，已打开订单支付状态。'
      }
    }
    if (!revisionStarted && currentOrder.value
        && (orderId || route.query.paymentReturn === '1' || canPay.value || Number(currentOrder.value.bankTransferStatus) === 1)) {
      step.value = 'pay'
      if (Number(currentOrder.value.bankTransferStatus) > 0) {
        payMethod.value = 'BANK_TRANSFER'
      } else {
        const method = String(currentOrder.value.payMethod || '').toUpperCase()
        payMethod.value = orderAllowedPaymentMethods.value.includes(method)
          ? method
          : orderAllowedPaymentMethods.value[0] || 'ALIPAY'
      }
    }
    if (route.query.paymentReturn === '1' && currentOrder.value) {
      paymentOpened.value = true
      await checkPaymentStatus(false)
      if (canPay.value && payMethod.value === 'ALIPAY') startPolling()
    }
  } catch (error) {
    pageMessage.value = error.message || '下单信息加载失败'
  } finally {
    pageLoading.value = false
  }
}

function onAuthExpired() {
  router.replace({ path: '/mobile/login', query: { redirect: route.fullPath } })
}

watch(sameServiceContact, enabled => {
  if (enabled) syncServiceContact()
})

/** 收货人变更只同步已启用的服务联系人，不修改独立填写的信息。 */
watch(
  () => [orderForm.receiverName, orderForm.receiverPhone],
  syncServiceContact,
  { flush: 'sync' }
)

/** 发货标识变化时立即清除残留收货信息，避免旧地址被再次同步或提交。 */
watch(selectedProductNeedDelivery, normalizeNoDeliveryForm, { flush: 'sync' })

/** 区域名称与编码保持一致；所有合同相关输入变化同步作废旧请求和确认。 */
watch(() => orderForm.cityPartnerRequest.regionCode, syncCityRegionName, { flush: 'sync' })
watch(contractContextKey, resetContractDraft, { flush: 'sync' })

watch(isCityPartnerPackage, enabled => {
  if (!enabled) {
    cityPartnerSelection.provinceCode = ''
    cityPartnerSelection.cityCode = ''
    resetCityPartnerRegion()
    return
  }
  orderForm.quantity = 1
  loadArea()
})

watch(
  () => [
    currentOrder.value?.id,
    currentOrder.value?.payMethod,
    currentOrder.value?.bankTransferStatus,
    visiblePaymentMethods.value.join(',')
  ],
  () => {
    if (Number(currentOrder.value?.bankTransferStatus) > 0) {
      payMethod.value = 'BANK_TRANSFER'
      return
    }
    const method = String(currentOrder.value?.payMethod || '').toUpperCase()
    payMethod.value = visiblePaymentMethods.value.includes(method)
      ? method
      : visiblePaymentMethods.value[0] || ''
  }
)

watch(() => currentOrder.value?.id, (orderId, previousOrderId) => {
  if (orderId === previousOrderId) return
  revokePaymentVoucherPreview()
  paymentVoucher.value = null
  paymentVoucherMessage.value = ''
})

onMounted(() => {
  window.addEventListener('website-auth-expired', onAuthExpired)
  initialize()
})

/** 离开下单页时停止轮询，并使未完成的合同与区域请求失效。 */
onBeforeUnmount(() => {
  window.removeEventListener('website-auth-expired', onAuthExpired)
  stopPolling()
  resetContractDraft()
  cityRegionRequestId += 1
})
</script>

<style scoped>
.order-screen { padding-bottom: calc(104px + env(safe-area-inset-bottom)); }
.order-screen-expanded { padding-bottom: calc(156px + env(safe-area-inset-bottom)); }
.mobile-topnav { display: grid; grid-template-columns: 64px minmax(0, 1fr) 64px; }
.nav-side { display: flex; justify-content: flex-start; }
.nav-service-side { justify-content: flex-end; }
.mobile-topnav-title { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: center; }
.service-trigger { height: 36px; display: inline-flex; align-items: center; justify-content: center; gap: 5px; padding: 0 10px; border: 1px solid var(--mobile-line); border-radius: 12px; color: var(--mobile-muted); font-size: 12px; font-weight: 800; background: rgba(255,255,255,.04); }
.service-trigger:active { color: var(--mobile-cyan); background: rgba(98,244,214,.1); }
.state-card { display: grid; gap: 12px; margin-top: 22px; color: var(--mobile-muted); font-size: 12.5px; text-align: center; }
.state-card.error { color: #ff9c9c; }
.state-card .mobile-btn { width: 100%; }
.order-progress { display: flex; align-items: center; gap: 10px; margin: 6px 0 14px; }
.order-progress span { flex: none; padding: 5px 10px; border: 1px solid var(--mobile-line); border-radius: 999px; color: var(--mobile-quiet); font-size: 10.5px; font-weight: 800; }
.order-progress .active { color: var(--mobile-cta-ink); border-color: transparent; background: linear-gradient(120deg, #8df5de, #46d6b6); }
.order-progress .done { color: var(--mobile-cyan); border-color: rgba(98,244,214,.34); background: rgba(98,244,214,.08); }
.order-progress i { flex: 1; height: 1px; background: var(--mobile-line); }
.order-body { display: grid; gap: 13px; }
.checkout-product, .checkout-unavailable { margin-bottom: 13px; }
.product-card h1, .pay-card h1 { margin: 9px 0 6px; font-size: 21px; line-height: 1.25; font-weight: 900; }
.product-card p, .pay-card p { color: var(--mobile-muted); font-size: 11.5px; line-height: 1.65; }
.product-select { display: grid; gap: 7px; margin-top: 12px; }
.product-subtitle { margin-top: 5px; }
.product-condition { display: grid; gap: 7px; margin-top: 11px; padding: 11px 12px; border: 1px solid var(--mobile-line); border-radius: 12px; background: rgba(255,255,255,.025); }
.product-condition span { color: var(--mobile-gold); font-size: 10px; font-weight: 800; letter-spacing: .08em; }
.product-condition p { margin: 0; }
.product-payment-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 11px; }
.product-payment-tags span, .region-message { padding: 3px 8px; border: 1px solid var(--mobile-line-strong); border-radius: 7px; color: var(--mobile-muted); font-size: 10px; font-weight: 750; background: rgba(255,255,255,.03); }
.region-message { margin: 0; border-color: rgba(98,244,214,.24); color: var(--mobile-quiet); font-size: 11px; font-weight: 650; line-height: 1.65; background: rgba(98,244,214,.05); }
.voucher-upload { display: grid; gap: 9px; margin-top: 13px; padding: 12px; border: 1px dashed var(--mobile-line); border-radius: 14px; background: rgba(255,255,255,.025); }
.voucher-upload > div:first-child { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.voucher-upload strong { color: var(--mobile-ink); font-size: 13px; font-weight: 900; }
.voucher-upload > div:first-child span { color: #ffd5a3; font-size: 11px; font-weight: 800; }
.voucher-upload input[type='file'] { display: none; }
.voucher-upload > button { min-height: 40px; border: 1px solid rgba(98,244,214,.35); border-radius: 12px; color: var(--mobile-cyan); font-size: 12.5px; font-weight: 850; background: rgba(98,244,214,.08); }
.voucher-preview { display: grid; grid-template-columns: 82px minmax(0, 1fr); gap: 10px; align-items: center; }
.voucher-preview img { width: 82px; height: 82px; object-fit: cover; border: 1px solid var(--mobile-line-strong); border-radius: 11px; background: rgba(255,255,255,.05); }
.voucher-preview span { color: var(--mobile-ink); font-size: 11.5px; font-weight: 800; word-break: break-all; }
.voucher-preview > div { display: grid; gap: 6px; justify-items: start; }
.voucher-preview a { color: var(--mobile-cyan); font-size: 11.5px; font-weight: 750; }
.voucher-preview button { padding: 0; border: 0; color: #ff9c9c; font-size: 11.5px; font-weight: 800; background: none; }
.voucher-preview-actions { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; }
.voucher-upload small { color: #ff9c9c; font-size: 11px; line-height: 1.5; }
.voucher-upload p { margin: 0; }
.price-row, .pay-amount { display: flex; align-items: baseline; justify-content: space-between; margin-top: 14px; padding-top: 12px; border-top: 1px dashed var(--mobile-line); }
.price-row span, .pay-meta dt { color: var(--mobile-quiet); font-size: 11px; font-weight: 700; }
.price-row strong, .pay-amount { color: var(--mobile-cyan); font-size: 22px; font-weight: 900; }
.pay-amount { justify-content: flex-end; }
.form-card h2, .agreement-card h2, .method-card h2, .bank-card h2 { margin-bottom: 13px; font-size: 15px; font-weight: 900; }
.form-card { display: grid; grid-template-columns: minmax(0, 1fr); gap: 11px; }
.form-card label { display: grid; gap: 6px; }
.form-card .wide { grid-column: 1 / -1; }
.form-card span { color: var(--mobile-quiet); font-size: 11.5px; font-weight: 700; }
input, select, textarea { width: 100%; min-height: 48px; padding: 0 13px; border: 1px solid var(--mobile-line); border-radius: 12px; color: var(--mobile-ink); background: rgba(255,255,255,.035); outline: none; }
textarea { padding-top: 12px; resize: none; }
input:focus, select:focus, textarea:focus { border-color: rgba(98,244,214,.55); box-shadow: 0 0 0 3px rgba(98,244,214,.08); }
select { appearance: none; background-image: linear-gradient(45deg, transparent 49%, var(--mobile-muted) 50%), linear-gradient(-45deg, transparent 49%, var(--mobile-muted) 50%); background-position: calc(100% - 19px) 50%, calc(100% - 13px) 50%; background-size: 6px 6px; background-repeat: no-repeat; }
.quantity-row { grid-column: 1 / -1; display: flex; align-items: center; justify-content: space-between; color: var(--mobile-quiet); font-size: 11.5px; font-weight: 700; }
.quantity-row div { display: flex; align-items: center; gap: 4px; }
.quantity-row button { width: 36px; height: 36px; border: 1px solid var(--mobile-line-strong); border-radius: 11px; color: var(--mobile-cyan); font-size: 18px; background: rgba(255,255,255,.035); }
.quantity-row strong { width: 34px; color: var(--mobile-ink); font-size: 15px; text-align: center; }
.switch-row { grid-column: 1 / -1; display: flex; align-items: center; gap: 8px; color: var(--mobile-muted); font-size: 12px; }
.switch-row input { width: 16px; min-height: 16px; height: 16px; accent-color: #46d6b6; }
.summary-card > dl, .pay-meta, .bank-card > dl { display: grid; gap: 9px; }
.summary-card > dl > div, .pay-meta > div, .bank-card > dl > div { display: flex; justify-content: space-between; gap: 14px; }
.summary-card dt, .pay-meta dt, .bank-card dt { flex: none; color: var(--mobile-quiet); font-size: 11.5px; font-weight: 700; }
.summary-card dd, .pay-meta dd, .bank-card dd { color: var(--mobile-ink); font-size: 12px; font-weight: 700; text-align: right; word-break: break-all; }
.agreement-item { padding: 12px 0; border-bottom: 1px dashed var(--mobile-line); }
.agreement-item:last-child { border-bottom: 0; }
.agreement-item summary { color: var(--mobile-cyan); font-size: 13px; font-weight: 800; }
.agreement-content { max-height: 260px; overflow-y: auto; margin-top: 10px; padding-right: 5px; color: var(--mobile-muted); font-size: 11.5px; line-height: 1.75; }
.agreement-item label { display: flex; align-items: center; gap: 8px; margin-top: 10px; color: var(--mobile-muted); font-size: 12px; }
.agreement-item input { width: 16px; min-height: 16px; height: 16px; accent-color: #46d6b6; }
.contract-draft-card { margin-top: 12px; }
.contract-draft-note { margin: -4px 0 4px; color: var(--mobile-muted); font-size: 11.5px; line-height: 1.7; }
.contract-draft-title { display: flex; align-items: flex-start; justify-content: space-between; gap: 10px; }
.contract-draft-title strong { color: #dff7f1; font-size: 13px; line-height: 1.5; }
.contract-draft-title span { flex: none; color: var(--mobile-muted); font-size: 11px; }
.contract-draft-actions { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px 10px; align-items: center; margin-top: 10px; }
.contract-draft-actions .mobile-btn { width: 100%; min-height: 34px; padding: 0 8px; font-size: 11.5px; white-space: nowrap; }
.contract-draft-actions label { grid-column: 1 / -1; display: flex; align-items: center; gap: 7px; margin: 0; color: var(--mobile-muted); font-size: 12px; }
.contract-draft-actions input { width: 16px; min-height: 16px; height: 16px; accent-color: #46d6b6; }
.region-message.error { color: #ff8f8f; }
.method-card { display: grid; gap: 9px; }
.method-card button { min-height: 62px; padding: 11px 14px; border: 1px solid var(--mobile-line); border-radius: 14px; text-align: left; background: rgba(255,255,255,.03); }
.method-card button.active { border-color: rgba(98,244,214,.5); background: rgba(98,244,214,.08); }
.method-card strong { display: block; font-size: 14px; font-weight: 900; }
.method-card span { display: block; margin-top: 3px; color: var(--mobile-quiet); font-size: 11px; }
.bank-card p { margin-top: 12px; color: var(--mobile-muted); font-size: 11.5px; line-height: 1.7; }
.field-error { color: #ff9c9c; font-size: 12px; line-height: 1.6; text-align: center; }
.dock { position: fixed; right: 0; bottom: 0; left: 0; z-index: 35; display: flex; align-items: center; gap: 12px; max-width: 540px; margin: 0 auto; padding: 12px 18px calc(12px + env(safe-area-inset-bottom)); border-top: 1px solid var(--mobile-line); background: linear-gradient(180deg, rgba(2,5,13,.72), rgba(2,5,13,.98)); backdrop-filter: blur(12px); }
.dock > div { flex: 1; min-width: 0; }
.dock small { display: block; color: var(--mobile-quiet); font-size: 10.5px; }
.dock strong { display: block; margin-top: 2px; color: var(--mobile-cyan); font-size: 20px; font-weight: 900; }
.dock .mobile-btn { flex: 0 0 auto; min-width: 138px; }
.dock-actions { flex-wrap: wrap; }
.dock-actions > div { flex: 1 1 100%; }
.dock-actions .mobile-btn { flex: 1 1 calc(50% - 6px); min-width: 0; padding-right: 6px; padding-left: 6px; font-size: 13.6px; white-space: nowrap; }
.dock-payment-return { flex-wrap: wrap; }
.dock-payment-return > div { flex: 1 1 100%; }
.dock-payment-return .mobile-btn { flex: 1 1 calc(50% - 6px); min-width: 0; padding-right: 6px; padding-left: 6px; font-size: 13.4px; white-space: nowrap; }
@media (max-width: 350px) { .order-screen { padding-bottom: calc(160px + env(safe-area-inset-bottom)); } .order-screen-expanded { padding-bottom: calc(216px + env(safe-area-inset-bottom)); } .dock:not(.dock-actions) { flex-wrap: wrap; } .dock:not(.dock-actions) .mobile-btn { flex: 1 1 100%; } .dock-actions .mobile-btn { flex: 1 1 100%; } }
.service-panel-mask { position: fixed; inset: 0; z-index: 100; display: flex; align-items: flex-end; justify-content: center; padding: 18px; background: rgba(1,4,10,.72); backdrop-filter: blur(6px); }
.service-panel { width: min(100%, 430px); display: grid; gap: 16px; padding: 20px 18px calc(18px + env(safe-area-inset-bottom)); border: 1px solid var(--mobile-line-strong); border-radius: 22px 22px 0 0; background: linear-gradient(170deg, rgba(18,31,52,.98), rgba(7,15,29,.99)); box-shadow: 0 -18px 50px rgba(0,0,0,.42); }
.service-panel header { display: grid; gap: 8px; }
.service-panel h2 { color: var(--mobile-ink); font-size: 19px; font-weight: 900; }
.service-loading { color: var(--mobile-muted); font-size: 12.5px; line-height: 1.7; text-align: center; }
.service-panel figure { display: grid; justify-items: center; gap: 9px; padding: 14px; border: 1px dashed var(--mobile-line); border-radius: 16px; background: rgba(255,255,255,.03); }
.service-panel img { display: block; width: 168px; height: 168px; object-fit: contain; border-radius: 12px; background: #fff; }
.service-panel figcaption { color: var(--mobile-muted); font-size: 12px; font-weight: 700; }
.service-mail { display: flex; flex-direction: column; gap: 3px; padding: 13px 14px; border: 1px solid var(--mobile-line); border-radius: 15px; text-decoration: none; background: rgba(98,244,214,.06); }
.service-mail span { color: var(--mobile-quiet); font-size: 11px; font-weight: 800; }
.service-mail strong { color: var(--mobile-cyan); font-size: 14px; font-weight: 900; word-break: break-all; }
</style>
